export default {
  common: {
    nav: {
      home: "Головна",
      find_offer_help: "Знайти / Запропонувати допомогу",
      celebrate: "Вшанувати життя",
      family_tree: "Родинне дерево",
      events: "Події",
      civic_reports: "Громадські звіти",
      neighborhood_pulse: "Пульс району",
      weather: "Погода",
      nature: "Природа",
      marketplace: "Ринок",
      news: "Новини",
      causes: "Ініціативи",
      more: "Більше",
    },
    header: { sign_in: "Увійти", join: "Приєднатися до Social Pulse", language: "Мова", search: "Пошук" },
    tagline: "З'єднуємо громади · Розширюємо можливості життя · Будуємо соціальний капітал",
    locality: { viewing_from: "Ви переглядаєте з", change: "Змінити", set_your_location: "Встановити ваше місцезнаходження" },
    news: { title: "Ваш щоденний огляд.", play_briefing: "Відтворити щоденний огляд", listen: "Слухати", translate: "Перекласти" },
  },
};
